import React from 'react';
import { blue, grey } from '@mui/material/colors';
import { Listing } from 'components/shared/TableListing';

import { getReportsListingConfig } from './reportsListingConfig';
import { ReportListingAfterGroup } from './ReportListingAfterGroup';
import { ReportListingBeforeGroup } from './ReportListingBeforeGroup';
import { FullReportResponse, GroupsSummaryData, ReportsListingContext, ReportsListingViewModel } from '../../types';

interface Props {
  loading: boolean;
  allGroupsOpen: boolean;
  list: FullReportResponse['list'];
  summary: GroupsSummaryData | undefined;
}

export const ReportListing = ({ summary, loading, allGroupsOpen, list }: Props) => {
  const columns = getReportsListingConfig();

  return (
    <Listing<ReportsListingViewModel, ReportsListingContext>
      tableData={[]}
      loading={loading}
      columns={columns}
      staticSettings={{ allGroupsOpen }}
      injectContext={{
        totals: {
          grossProfit: summary?.grossProfitTotal ?? 0,
          invoiceAmount: summary?.invoiceAmountTotal ?? 0,
          weightedAmount: summary?.weightedAmountTotal ?? 0,
        },
      }}
      groups={list.map(group => ({
        name: group.name,
        data: group?.data ?? [],
        beforeGroup: {
          render: () => <ReportListingBeforeGroup group={group} />,
          cellStyles: {
            backgroundColor: grey[50],
          },
        },
        afterGroup: {
          render: () => <ReportListingAfterGroup group={group} />,
          cellStyles: {
            backgroundColor: blue[50],
          },
        },
      }))}
    />
  );
};
